import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter';
import { dataGridTextSorter } from '../../../../common/DataGrid/sorters/DataGridSorters';
import DataGrid from '../../../../common/DataGrid/DataGrid';

const ErasmusConsortiumTable = ({
  erasmusConsortiums,
  onDelete,
  onDetailClick,
  onPreviewClick,
}) => {
  const { t } = useTranslation();

  const NameFilterProps = useDataGridTextFilter('name');

  const columns = useMemo(
    () => [
      {
        title: 'Názov',
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        defaultSortOrder: 'ascend',
        ...NameFilterProps,
      },
    ],
    [t, NameFilterProps],
  );

  return (
    <DataGrid
      rowKey={(consortium) => consortium.id}
      columns={columns}
      dataSource={erasmusConsortiums || []}
      permissionsBasic={'erasmus-universities'}
      onEditClick={onDetailClick}
      onRowClick={onDetailClick}
      onDelete={onDelete}
      onPreviewClick={onPreviewClick}
      rowClickOpensPreview
    />
  );
};

ErasmusConsortiumTable.propTypes = {
  erasmusConsortiums: PropTypes.array,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
  onCreateClick: PropTypes.func,
};

export default ErasmusConsortiumTable;
